import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, apiError } from "@/lib/api";
import { formatTRY } from "@/lib/format";
import { Field, sel, todayIso } from "@/lib/finance";

// v1.37.1 İnşaat Giderine Ver: evrak inşaat giderini öder (gider kaydı evrakla ödenmiş; kasa/banka hareketi yok)
export default function InsaatGiveForm({ ins, onDone }) {
  const [projects, setProjects] = useState([]);
  const [cats, setCats] = useState([]);
  const [f, setF] = useState({ project_id: "", category_id: "", gider_turu: "belirtilmemis", given_to: "", date: todayIso(), note: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/insaat/projects", { params: { status: "aktif" } }).then(({ data }) => { setProjects(data.items); setF((x) => ({ ...x, project_id: data.items[0]?.id || "" })); }).catch((e) => toast.error(apiError(e)));
    api.get("/insaat/categories").then(({ data }) => { setCats(data.items); setF((x) => ({ ...x, category_id: data.items[0]?.id || "" })); }).catch(() => {});
  }, []);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const go = async () => {
    setBusy(true);
    try { await api.post(`/cek-senet/${ins.id}/insaat`, { ...f, given_to: f.given_to || null, note: f.note || null }); toast.success(`${ins.portfolio_no} inşaat giderine verildi`); onDone(); }
    catch (e) { toast.error(apiError(e)); }
    setBusy(false);
  };
  return (
    <div className="p-3 rounded border border-orange-200 bg-orange-50/50 space-y-2" data-testid="instrument-insaat-form">
      <div className="text-[12px] text-slate-600">Evrak ({formatTRY(ins.amount)}) seçilen inşaatın gideri olarak kaydedilir ve ödeme "Çek/Senet ile ödendi" olur. Kasa/banka hareketi oluşmaz; vadeye kadar müşteri riski sürer.</div>
      <div className="grid grid-cols-2 gap-2">
        <Field label="İnşaat / Şantiye"><select className={`${sel} w-full`} value={f.project_id} onChange={set("project_id")} data-testid="insaat-project">{projects.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}</select></Field>
        <Field label="Gider kalemi"><select className={`${sel} w-full`} value={f.category_id} onChange={set("category_id")} data-testid="insaat-category">{cats.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}</select></Field>
        <Field label="Gider türü"><select className={`${sel} w-full`} value={f.gider_turu} onChange={set("gider_turu")} data-testid="insaat-type">
          {[["belirtilmemis", "Belirtilmemiş"], ["malzeme", "Malzeme"], ["iscilik", "İşçilik"], ["hizmet", "Hizmet"]].map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select></Field>
        <Field label="Verilen kişi/firma (ops.)"><Input value={f.given_to} onChange={set("given_to")} data-testid="insaat-given-to" /></Field>
        <Field label="Tarih"><Input type="date" value={f.date} onChange={set("date")} data-testid="insaat-date" /></Field>
        <Field label="Not"><Input value={f.note} onChange={set("note")} data-testid="insaat-note" /></Field>
      </div>
      <Button size="sm" disabled={busy || !f.project_id || !f.category_id} onClick={go} className="bg-orange-600 hover:bg-orange-700" data-testid="insaat-submit">İnşaat Giderine Ver</Button>
    </div>
  );
}
